import { Scanner, Stream } from './scanner';
import { Drawing } from './drawing';

export enum TypeActivePicture {
  Drawing = 'drawing',
  Scanner = 'scanner',
  File = 'file',
}

export enum TypeActionOnActivePicture {
  Clear = 'clear',
  TakePhoto = 'scanner',
  SwitchCamera = 'switch',
}

export class ActivePicture {
  public static create(type: TypeActivePicture, id: string, data?: string) {
    switch (type) {
      case TypeActivePicture.Drawing:
        new Drawing(id, data);
        return null;
      case TypeActivePicture.Scanner: {
        const camera = new Scanner(id, data);
        return camera.getActiveVideo();
      }
      case TypeActivePicture.File:
        return null;
    }
  }
  public static doAction(
    typeAction: TypeActionOnActivePicture,
    type: TypeActivePicture,
    id: string,
  ) {
    switch (type) {
      case TypeActivePicture.Drawing:
        typeAction === TypeActionOnActivePicture.Clear && Drawing.clear(id);
        break;
      case TypeActivePicture.Scanner:
        typeAction === TypeActionOnActivePicture.Clear && Scanner.clear(id);
        typeAction === TypeActionOnActivePicture.TakePhoto &&
          Scanner.takePhoto(id);
        typeAction === TypeActionOnActivePicture.SwitchCamera &&
          Scanner.switchCamera(id);
        break;
    }
  }

  public static getDataUrl(
    type: TypeActivePicture | undefined,
    canvas: HTMLElement,
    paramCheckComplex?: number[],
  ) {
    if (!type) {
      return undefined;
    }
    switch (type) {
      case TypeActivePicture.Drawing:
        return Drawing.getDrawingAsDataUrl(
          canvas as HTMLCanvasElement,
          paramCheckComplex,
        );
      case TypeActivePicture.Scanner:
        return Scanner.getPhotoAsDataUrl(canvas);
    }
  }

  public static getProblemCode(
    type: TypeActivePicture | undefined,
    canvas: HTMLElement,
    paramCheckComplex?: number[],
  ) {
    if (!type) {
      return 0;
    }
    switch (type) {
      case TypeActivePicture.Drawing:
        return Drawing.getProblemDrawingCode(
          canvas as HTMLCanvasElement,
          paramCheckComplex,
        );
      case TypeActivePicture.Scanner:
        return 0;
      case TypeActivePicture.File:
        return 0;
    }
  }

  public static stopVideo(video: HTMLVideoElement) {
    Stream.stopVideo(video);
  }
}
